// extracted by mini-css-extract-plugin
module.exports = {"cta-newsletter":"styles-m__cta-newsletter__3QqYm"};